import React from 'react';

/**
 * Small restorable chip shown on chat messages that produced an artifact version,
 * e.g. "Query v3 ✓". Clicking it restores that version into the editor.
 */
export const AiArtifactVersionChip = ({ label, ok, title, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      marginTop: 4,
      padding: '3px 10px',
      borderRadius: 12,
      border: '1px solid #90caf9',
      background: '#e3f2fd',
      color: '#0d47a1',
      fontSize: 11,
      fontWeight: 600,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
    }}
  >
    <span>{label}</span>
    {ok != null && (
      <span style={{ color: ok ? '#2e7d32' : '#e65100', fontWeight: 700 }}>
        {ok ? '\u2713' : '!'}
      </span>
    )}
  </button>
);
